<template>
  <b-overlay :show="isLoading" no-body>
    <b-tabs pills vertical class="p-md-3 px-sm-2">
      <b-tab v-if="permissions.includes('vns_monitor.tipo_info')"
             :title="$t('monitoramento.resumo.tabs.informacoes.title')"
             lazy>
        <Overview/>
      </b-tab>
      <b-tab v-if="canAccessRoot"
             :title="$t('monitoramento.resumo.tabs.comandos.title')"
             lazy>
        <Commands/>
      </b-tab>
      <b-tab v-if="permissions.includes('vns_monitor.tipo_latency')"
             :title="$t('monitoramento.resumo.tabs.latencia.title')"
             lazy>
        <Latency/>
      </b-tab>
      <b-tab v-if="permissions.includes('vns_monitor.tipo_temperature')"
             :title="$t('monitoramento.resumo.tabs.temperatura.title')"
             lazy>
        <Temperature/>
      </b-tab>
      <b-tab v-if="permissions.includes('vns_monitor.tipo_location')"
             :title="$t('monitoramento.resumo.tabs.localizacao.title')"
             lazy>
        <b-card-text>
          <div v-if="Object.keys(geolocation).length > 0">
            <GmapMap :center="geolocation" :zoom="15" map-type-id="terrain" style="width:600px;height:400px;margin:auto;">
              <GmapMarker :position="geolocation" :clickable="true" :draggable="true"/>
            </GmapMap>
            <p class="w-100 text-center mt-3">{{ $t('monitoramento.resumo.tabs.localizacao.ultima') }}: {{ geolocation.created_at | formatDate }}</p>
          </div>
          <p v-else class="w-100 text-center mt-3">{{ $t('monitoramento.resumo.tabs.localizacao.nenhuma_localizacao') }}</p>
        </b-card-text>
      </b-tab>
      <b-tab v-if="permissions.includes('vns_monitor.tipo_jira')"
             :title="$t('monitoramento.resumo.tabs.jira.title')"
             lazy>             
        <Jira/>
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import Overview from "@/pages/vns/components/Monitor/Overview";
import Commands from "@/pages/vns/components/Monitor/Commands";
import Latency from "@/pages/vns/components/Monitor/Latency";
import Temperature from "@/pages/vns/components/Monitor/Temperature";
import Jira from "@/pages/vns/components/Monitor/Jira";

export default {
  name: "Monitor",
  components: {
    Temperature,
    Latency,
    Overview,
    Commands,
    Jira
  },
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      isLoading: 'vns/isLoading',
      geolocation: 'vns/monitor/getGeolocation'
    })
  },
  data() {
    return {
      permissions: [],
      canAccessRoot: false
      
    }
  },
  methods: {
    ...mapActions([
      'vns/monitor/listLastGeolocation',
    ]),
    hasPerfil(perfil) {
      return hasPerfil(perfil)
    }
  },
  filters: {
    formatDate: (value, time = true) => {
      if (!time) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
      return moment(String(value)).format('DD/MM/YYYY H:mm:ss')
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  mounted() {
    this.$store.commit('vns/monitor/setGeolocation', {})
    this['vns/monitor/listLastGeolocation'](this.vns.id)
  }
}
</script>
